import { useState, useEffect } from "react";
import TiltingPlane from "../TiltingPlane";
import Slider from "./Slider";
import styled from "styled-components";
import IconButton from "../buttons/IconButton";
import { useAppSelector } from "../../hooks";
import { Direction } from "./Slider";

const Styled = styled.div`
  height: 100%;
  width: 100%;
  padding: 1em linear;
  display: grid;
  transform-origin: center;
  height: 60%;
  div {
    grid-column: 1 / -1;
    grid-row: 1 / -1;
  }

  .slider-buttons {
    width: 90%;
    margin-left: 5%;
    height: 100%;
    display: flex;
    z-index: 2;
    justify-content: space-between;
  }
  .game-logo-container {
    height: 100%;
    width: 140%;
    margin-left: -20%;
    display: flex;
    justify-content: center;

    .game-logo {
      background-size: contain;
      background-position: center calc(50% + 4.5em);
      background-repeat: no-repeat;
      height: 120%;
      width: 120%;
      max-width: 1000px;
      background-image: url("/ui/game/images/en/loading-screen/logos/game.webp");
    }
  }
` as any;

const getAngle = (x: number, y: number) => {
  const centerX = 0;
  const centerY = 0;

  const deltaX = x - centerX;
  const deltaY = y - centerY;

  let angleRad = Math.atan2(deltaY, deltaX);
  let angleDeg = angleRad * (180 / Math.PI);

  return angleDeg < 0 ? angleDeg + 360 : angleDeg; // Normalize to 0-360 degrees
};

const Pages: React.FC<{ slides: { landscape: string[]; portrait: string[] } }> =
  ({ slides }) => {
    const [tilt, setTilt] = useState({ x: 0, y: 0, z: 0 });
    const [index, setIndex] = useState(0);
    const [slideDirection, setSlideDirection] = useState(null as null | Direction);
    const onButtonClick = (index: number, direction: Direction) => {
      setIndex(index);
      setSlideDirection(direction);
    };
    const layout = useAppSelector(
      (state) => state.layout,
      (o, n) => o.name === n.name
    );

    const layout_slides =
      layout.name === "portrait" ? slides.portrait : slides.landscape;

    useEffect(() => {
      const onMove = (e: any) => {
        const width = window.innerWidth / 2;
        const height = window.innerHeight / 2;
        const x = -(width - e.clientX) / width;
        const y = -(e.clientY - height) / height;
        const z = 1 - Math.abs(45 - (getAngle(x, y) % 90)) / 45;

        setTilt({ x, y, z });
      };
      window.addEventListener("mousemove", onMove);

      return () => window.removeEventListener("mousemove", onMove);
    }, []);

    return (
      <Styled>
        <TiltingPlane
          tilt={tilt}
          tiltBase={{ x: 8, y: 6, z: 0 }}
          className="slides"
        >
          <Slider index={index} direction={slideDirection} slides={layout_slides} />
        </TiltingPlane>
        <TiltingPlane tilt={tilt} tiltBase={{ x: 3, y: 3, z: 0 }}>
          <div className="game-logo-container">
            <div className="game-logo"></div>
          </div>
        </TiltingPlane>

        <div className="slider-buttons">
          <IconButton
            clickDelay={1000}
            className="flipped color"
            onClick={() =>
              onButtonClick(
                index !== 0 ? index - 1 : layout_slides.length - 1,
                "left"
              )
            }
            type="Chevron"
            size={60}
            color="rgba(255, 255, 255, 0.7)"
            name="stake-selector-previous"
            available={layout_slides.length > 1}
          />
          <IconButton
            className=""
            clickDelay={1000}
            onClick={() =>
              onButtonClick((index + 1) % layout_slides.length, "right")
            }
            type="Chevron"
            size={60}
            color="rgba(255, 255, 255, 0.7)"
            name="stake-selector-next"
            available={layout_slides.length > 1}
          />
        </div>
      </Styled>
    );
  };

export default Pages;
